var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataOrigin.state === 'progress-view')?_c('div',{staticClass:"progress-view pa-1",class:{
    'pl-7':
      _vm.$vuetify.breakpoint.lgAndUp && !_vm.withoutTitle && _vm.origin !== 'cardsale'
  }},[(_vm.origin !== 'cardsale')?_c('span',{staticClass:"fonte fonteMini grey--text"},[_vm._v(" Envolvidos: ")]):_vm._e(),(_vm.origin === 'sale')?_c('sale',{attrs:{"dataOrigin":_vm.dataOrigin}}):_vm._e(),(_vm.origin === 'cardsale')?_c('cardsale',{attrs:{"dataOrigin":_vm.dataOrigin}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }